<template>
	<div
		class="resource-audience"
		:class="{
			'resource-audience-line': line,
		}"
		:title="audienceName"
	>
		<div
			v-if="showLetter"
			class="letter"
		>
			{{ letter }}
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { capitalise } from '@/helpers';
import { getAudienceFromKey, type ResourceAudienceKey } from '@/interfaces/resourceFilterInterface';

export default defineComponent({
	props: {
		audience: {
			type: String as PropType<ResourceAudienceKey>,
			default: null,
		},
		size: {
			type: Number,
			default: 20,
		},
		line: {
			type: Boolean,
			default: false,
		},
		showLetter: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		audienceName() {
			return `${capitalise(this.audience)} resource`;
		},
		color() {
			return getAudienceFromKey(this.audience).color;
		},
		sizePx() {
			return `${this.size}px`;
		},
		letter() {
			return this.audience ? this.audience[0].toUpperCase() : '';
		},
	},
});
</script>

<style scoped lang="scss">
.resource-audience {
	--color: v-bind('color');
	--size: v-bind('sizePx');

	position: absolute;
	top: 0;
	right: 0;
	border-width: 0 var(--size) var(--size) 0;
	border-style: solid;
	border-color: transparent rgba(var(--color)) transparent transparent;
	width: 0;
	height: 0;

	&.resource-audience-line {
		&::after {
			position: absolute;
			top: 0;
			right: -5px;
			background: rgb(var(--color));
			background: linear-gradient(90deg, rgba(var(--rs-color-brand-grey-text)) 0%, rgba(var(--color)) 100%);
			width: 60px;
			height: 1px;
			content: '';
		}
	}

	.letter {
		position: absolute;
		top: -5px;
		right: -18px;
		pointer-events: none;
		color: white;
		font-weight: bold;
		font-size: 9px;
	}
}
</style>
